import { InputBase, styled } from '@mui/material';
import { colorPalettes } from '../../../context/theme';
import { Flex } from '../Flex';

export const StyledSearchIconWrapper = styled('button')(({ theme }) => ({
  padding: '0 1.6rem 0 1.2rem',
  alignItems: 'center',
  justifyContent: 'center',
  color: colorPalettes[theme.palette.mode].components.Search.icon.color,
  cursor: 'pointer',
  background:
    colorPalettes[theme.palette.mode].components.Search.icon.background.primary,
  border: 'none',
  borderRadius: '0 22px 22px 0',
  display: 'flex',

  '&:hover': {
    background:
      colorPalettes[theme.palette.mode].components.Search.icon.background.hover,
  },
}));

export const StyledInputBase = styled(InputBase)`
  color: inherit;
  width: 100%;

  & .MuiInputBase-input {
    color: ${({ theme }) =>
      colorPalettes[theme.palette.mode].components.Search.text.primary};
    padding: 0.8rem 0.8rem 0.8rem 1.8rem;
    width: 100%;
    font-weight: 300;
    font-size: 1.4rem;

    ::placeholder {
      color: ${({ theme }) =>
        colorPalettes[theme.palette.mode].components.Search.text.placeholder};
      font-style: italic;
    }
  }
`;

interface StyledSearchProps {
  isSearched?: boolean;
}

export const StyledSearch = styled(Flex)<StyledSearchProps>(
  ({ theme, isSearched }) => ({
    position: 'relative',
    borderRadius: '22px',
    width: '100%',
    background: colorPalettes[theme.palette.mode].components.Search.background,
    outline: `1px solid transparent`,

    '&:focus-within': {
      outline: `1px solid ${
        colorPalettes[theme.palette.mode].components.Search.icon.border
      }`,

      [String(StyledSearchIconWrapper)]: {
        background: isSearched
          ? 'none'
          : colorPalettes[theme.palette.mode].components.Search.icon.background
              .withValue,
      },
    },
    '&:hover': {
      outline: `1px solid ${
        colorPalettes[theme.palette.mode].components.Search.icon.border
      }`,

      [String(StyledSearchIconWrapper)]: {
        '&:hover': {
          background: isSearched
            ? 'none'
            : colorPalettes[theme.palette.mode].components.Search.icon
                .background.hover,
        },
      },
    },
  }),
);
